<template>
    <nav>
        <v-app-bar
            absolute
            app 
        >
            <v-app-bar-nav-icon v-if="auth && validateAuth"  class="primary--text" @click="drawer = !drawer"></v-app-bar-nav-icon>
            
            <v-toolbar-title class="text-uppercase primary--text text-sm-subtitle-1">
                <span class="font-weight-light font-italic">Rapid</span>
                <span>Quote</span>
            </v-toolbar-title>
            <v-spacer></v-spacer>
            
            <v-btn v-if="auth" text outlined class="grey lighten-4 d-none d-flex-md" fab v-show="!drawer">
                <v-icon>mdi-account-circle</v-icon>
            </v-btn>
            <!--<v-btn text :class="[!currentPage.includes('Home') ? activeClass: 'no-active ma-2 light-green--text', 'no-active ma-2']" to="/">-->
            <!--    <span>-->
            <!--        Home-->
            <!--    </span>-->
            <!--</v-btn>-->
            <!--<v-btn text :class="[!currentPage.includes('About') ? activeClass: 'no-active ma-2 light-green--text', 'no-active ma-2']" to="/about">-->
            <!--    <span>-->
            <!--        About-->
            <!--    </span>-->
            <!--</v-btn>-->
            <v-btn text v-if="!(auth && validateAuth)" :class="[!currentPage.includes('Login') ? activeClass: 'no-active ma-2  primary--text', 'no-active ma-2']" to="/">
                <span>
                    Login
                </span>
            </v-btn>
            <v-btn text v-if="auth && validateAuth" class="no-active ml-0 mr-0 pr-0 pl-0 pr-md-2 pl-md-2 ma-md-2" @click="Logout">
                <span>
                    Sign Out
                </span>
            </v-btn>
        
        </v-app-bar>
        <v-navigation-drawer v-if="auth && validateAuth" v-model="drawer" app class="primary" dark>
            <NavList />
        </v-navigation-drawer>
    </nav>
</template>
<style scoped>
  .v-btn--active.no-active::before {                                                                             
    opacity: 0 !important;
  }
</style>

<script>
import NavList from '@/components/navcomps/NavList';
import { mapActions, mapGetters } from 'vuex';

export default {
    components: { NavList },
    data() {
        return  {
            drawer: true,
            activeClass: '',
        };
    },
    computed: {
        ...mapGetters({ auth: 'ifAuthenticated'}),
        currentPage() {
            if (this.$route.meta.title !== null && this.$route.meta.title !== undefined){
                 return this.$route.meta.title;
            }
            return 'Loading'
        },
        validateAuth (){
            return this.checkAuth();
        }
    },
    methods: {...mapActions(['Logout', 'checkAuth']),}
};
</script>